var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top'),_c('div',{staticClass:"details_wrap container"},[_c('titleConfig',{attrs:{"title":_vm.langSet == 'cn' ? '新闻详情' : 'News Details',"type":2}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(
        _vm.langSet == 'cn'
          ? _vm.details.content
          : _vm.details.en_content
          ? _vm.details.en_content
          : _vm.details.content
      )}})],1),_c('bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }